export class ForgotPasswordDto {
  public username: string;
  public recaptchaToken: string = null;
}
